import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { openNotification } from 'src/components/helpers/notification'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { getMailingContentForUser, mailingsInfoListAction } from 'src/store/Slices/MailingsSlice'

const MobileMailingsInfo = ({
    mailingsInfoListActionList,
    mailingsInfoListActionListLoading,
    mailingsInfo,
    setMailingsInfo,
    mailingsContent,
    setVisible,
    setTab,
    mnemo
}) => {

    const dispatch = useDispatch()

    return (
        <>
            {mailingsInfoListActionList?.data?.value?.rows.map(element => {
                return (
                    <Card
                        loading={mailingsInfoListActionListLoading}
                        title={`Деталь рассылки №: ${element.id}`}
                        // extra={<Dropdown
                        //     menu={{
                        //         items,
                        //     }}
                        // >
                        //     <a onClick={() => { setAbonementInfo(element) }} className="text-primary text-decoration-none">
                        //         Действия <DownOutlined />
                        //     </a>
                        // </Dropdown>}
                        style={{ width: 330, marginTop: 16 }}
                        actions={[
                            <div onClick={() => {
                                setMailingsInfo(element)
                                setVisible({open: true})
                                dispatch(getMailingContentForUser({mailingId: mailingsContent.id, userId: element.userId}))
                                setTab('Детали рассылки')
                            }}>Сообщения</div>,
                        ]}
                        key={element.id}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>№:</div>
                                <div>ФИО:</div>
                                <div>Почта:</div>
                                <div>Телефон:</div>
                                <div>Дата отправки:</div>
                                <div>Статус отправки:</div>
                            </div>
                            <div>
                                <div>{element?.id ? element?.id : '-'}</div>
                                <div>{element?.fullname ? <Tooltip title={element?.fullname}>{element?.fullname.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.email ? <Tooltip title={element?.email}>{element?.email.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.phone ? element?.phone : '-'}</div>
                                <div>{element?.sendedDate ? <Tooltip title={element?.sendedDate}>{element?.sendedDate.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.status ? element?.status : '-'}</div>
                            </div>
                        </div>
                    </Card>
                )
            })}
            {/* <FloatButton
                disabled={(!mnemo?.children?.find(el => el.name === 'Справочник')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                style={{ right: 24 }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setIsOpenModal(true)
                }}
            /> */}
        </>
    )
}

export default MobileMailingsInfo